
import {APP_CONFIG} from "../../config/GeneralConfig";
import {UserViewSettings, UserViewSettingsProp} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {IncomingInvoice, IncomingInvoiceModule} from "../../models/accounting/IncomingInvoice";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, switchMap} from "rxjs/operators";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";

import {Identifier} from "../../models/common/Identifier";
import {OptionType} from "../../components/form/SearchableSelect";
import {ProjectId} from "../../models/projects/Project";

/** backend api path */
function apiPath( projectId: Identifier< number > ): string {
    return APP_CONFIG.baseWeb + `invoices/incoming/project/${ projectId.rawValue }/contractors`;
}


/** union of all Bill related action types */
export type IncomingInvoiceProjectContractorViewActionTypes = FetchIncomingInvoicesProjectContractorActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchIncomingInvoicesProjectContractorAction extends UserViewSettingsProp, ProjectId, ReduxAction< typeof FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR > {}
export interface FetchIncomingInvoicesProjectContractorSuccessAction extends ReduxAction<typeof FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_SUCCESS > {
    payload: ApiReturnType< OptionType[] >

}
export interface FetchIncomingInvoicesProjectContractorErrorAction extends  ErrorAction< typeof FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_ERROR >{}

export type FetchIncomingInvoicesProjectContractorActionTypes = FetchIncomingInvoicesProjectContractorAction
    | FetchIncomingInvoicesProjectContractorSuccessAction
    | FetchIncomingInvoicesProjectContractorErrorAction

/**
 * redux action constants
 */
export const FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR = "FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR";
export const FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_SUCCESS = "FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_SUCCESS";
export const FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_ERROR = "FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_ERROR";

/**
 * redux action functions
 */
export function fetchIncomingInvoicesProjectContractor( projectId: Identifier< number >, userViewSettings: UserViewSettings ) : FetchIncomingInvoicesProjectContractorAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR, userViewSettings, projectId };
}
export function fetchIncomingInvoicesProjectContractorSuccess( payload: ApiReturnType< OptionType[] >) : FetchIncomingInvoicesProjectContractorSuccessAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_SUCCESS, payload };
}
export function fetchIncomingInvoicesProjectContractorError( error: Error ): FetchIncomingInvoicesProjectContractorErrorAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR_ERROR, error };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchIncomingInvoicesProjectContractorEpic(
    action$: Observable< FetchIncomingInvoicesProjectContractorAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType(FETCH_INCOMING_INVOICES_PROJECT_CONTRACTOR),
        switchMap(action => {
            const path = `${ apiPath( action.projectId ) }${  getUrlParamsFromViewSettings( action.userViewSettings ) }`;

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => fetchIncomingInvoicesProjectContractorSuccess(
                    response.response as ApiReturnType< OptionType[] >
                )),
                catchError(error => of(
                    fetchIncomingInvoicesProjectContractorError( error),
                    eventNotificationError(error, store$, IncomingInvoiceModule.identifier, "fetchIncomingInvoicesProjectContractor")
                ))
            );

        })
    );
}